import React, { useEffect, useState } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useElementPosition } from '../../hooks/useElementPosition';

export type RenderChildrenArgs = {
    isVisible: boolean;
};

export type IsInViewportProps = {
    children: (args: RenderChildrenArgs) => any;
    /**
     * The element must be visible for this amount of time before it is considered visible.
     */
    style?: StyleProp<ViewStyle>;
};

type _ViewMeasurement = {
    rectTop: number;
    rectBottom: number;
    rectWidth: number;
};

type LastIntervalMeasurement =
    | {
          isVisible: true;
          timestamp: number;
      }
    | { isVisible: false };

export const IsInViewport: React.FC<IsInViewportProps> = (props) => {
    const [lastIntervalMeasurement, setLastIntervalMeasurement] = useState<LastIntervalMeasurement | null>(null);
    const { ref, onLayout, position } = useElementPosition({});
    const isInViewPort = !!position?.isInViewport;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (isInViewPort && !lastIntervalMeasurement?.isVisible) {
            setLastIntervalMeasurement({
                isVisible: true,
                timestamp: Date.now(),
            });
        } else if (!isInViewPort && lastIntervalMeasurement?.isVisible) {
            setLastIntervalMeasurement({
                isVisible: false,
            });
        }
    });

    const isDebouncedVisible = lastIntervalMeasurement?.isVisible;

    return (
        <View collapsable={false} ref={ref} style={props.style} onLayout={onLayout}>
            {props.children({ isVisible: !!isDebouncedVisible })}
        </View>
    );
};

export default React.memo(IsInViewport);
